import PortalIdParser from 'PortalIdParser';
import userInfo from 'hub-http/userInfo';
import { fetchLastCreatedCta } from 'web-interactives-data/api/legacyCtas';
import { INITIALIZE_AUTH } from './ActionTypes';
import { getAiAccessControls } from '../api/aiaccess';
const aiAccessControlsDefault = {
  generativeAiEnabled: false,
  crmPropertiesEnabled: false,
  conversationDataEnabled: false,
  fileDataEnabled: false,
  copilotEnabled: false
};
export const initializeAuth = authParams => Object.assign({
  type: INITIALIZE_AUTH
}, authParams);
export const getAuth = () => dispatch => {
  PortalIdParser.get();
  return Promise.allSettled([userInfo(), fetchLastCreatedCta(), getAiAccessControls()]).then(([userDataResult, legacyCtaResult, aiAccessControlsResult]) => {
    if (userDataResult.status === 'rejected') {
      // Redirects to login anyway
      return null;
    }
    const userData = userDataResult.value;
    const hasLegacyCtas = legacyCtaResult.status === 'fulfilled' ? Boolean(legacyCtaResult.value) : false;
    const aiAccessControls = aiAccessControlsResult.status === 'fulfilled' ? aiAccessControlsResult.value : aiAccessControlsDefault;
    return dispatch(initializeAuth(Object.assign({}, userData, {
      hasLegacyCtas,
      aiAccessControls
    })));
  });
};